var React = require('react');

function SmallArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.5604 10.6362L3.55573 9.51995L15.0497 9.51528L10.454 4.91956L11.234 4.15827L17.1468 10.0711L11.2246 15.9932L10.4446 15.2132L15.045 10.6315L3.5604 10.6362Z"}));
}

SmallArrow.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = SmallArrow;

SmallArrow.default = SmallArrow;
